/**
 * 定义项目的全局函数
 */
import API from "./api.js";

export default {
  install(Vue, options) {
    // 将单位为分的价格，格式化为保留两位小数的元。
    Vue.prototype.formatPrice = function (price) {
      let p = price / 100
      p = p.toFixed(2)
      return p
    }

    // 将单位为元的价格格式化为两个小数点
    Vue.prototype.formatPriceFromYuan = function (price) {
      let p = price * 100 / 100
      p = p.toFixed(2)
      return p
    }

    // 合并对象的属性
    // isOverWrite : 是否覆盖
    // s: 源对象
    // r:目标对象
    // 返回：r对象
    Vue.prototype.$mergeObjectProps = function (r, s, isOverWrite) { // TODO:
      if (!s || !r) return r
      for (var p in s) {
        if (isOverWrite !== false || !(p in r)) {
          r[p] = s[p]
        }
      }
      return r
    }


    /**
     * [去除数组中重复的对象]
     * @return {type} [return value]
     */
    Vue.prototype.$deteleObject = function (arr) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < arr.length; i++) {
        var keys = Object.keys(arr[i]);
        keys.sort(function (a, b) {
          return (Number(a) - Number(b));
        });
        var str = '';
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(arr[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(arr[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    }


  }
}
